export function SearchSynonymsListForm(pObject, data) {
    var self = this;
    self.listData = ko.observable();
    self.dataList = ko.observableArray([]);

    self.saveAction = ko.observable();

    self.onAddNew = function() {
        var newSearchSynonyms = new SearchSynonyms(self, {
            id: null,
            synonymsString: '',
            isActive: true,
        });
        newSearchSynonyms.onEdit();
        self.dataList.push(newSearchSynonyms);
    };

    self.check = function(currentValue, index, array) {
        return currentValue.check();
    };

    self.onSave = function() {
        if (self.dataList().every(self.check)) {
            var d = JSON.stringify(
                self.dataList().map(function(c) {
                    return c.dump();
                })
            );
            self.listData(d);
            self.saveAction('save');
            $('#list-form').submit();
        }
    };

    self.onLoad = function() {
        self.dataList([]);
        if (data['objList']) {
            self.dataList(
                data['objList'].map(function(c) {
                    return new pObject(self, c);
                })
            );
        }
    };

    self.onLoad();
}

export function SearchSynonyms(parent, data) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.synonymsString = ko.observable(data['synonymsString']);
    self.isActive = ko.observable(data['isActive']);
    self.deleted = ko.observable(false);
    self.editInfo = ko.observable(false);
    self.parent = parent;

    self.onEdit = function() {
        self.editInfo(true);
    };

    self.onDelete = function() {
        self.deleted(!self.deleted());
    };

    self.check = function(backToEdit) {
        if (!self.synonymsString() && !self.deleted()) {
            var dialog = $('<p>Строка синонимов не может быть пустой.</p>').dialog({
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
                closeText: null,
            });
            return false;
        }

        return true;
    };

    self.dump = function() {
        return {
            id: self.id(),
            synonymsString: self.synonymsString(),
            isActive: self.isActive(),
            deleted: self.deleted(),
        };
    };
}
